module.exports = __webpack_public_path__ + "img/ingwersalatohnehintergrund.f7b95872.png";